import { Props } from 'docz';
import Playground from 'components/Playground';
import Tilt from "components/Tilt";
import * as React from 'react';
export default {
  Props,
  Playground,
  Tilt,
  React
};